import React from "react";
import { Card, Grid, Typography } from "@mui/material";

const darkCard = {
  backgroundColor: "#161B22",
  border: "1px solid rgba(255,255,255,0.06)",
};

export default function UtilityTable({
  municipalityTableData,
  isSuccessMunicipalityTableData,
}) {
  if (!isSuccessMunicipalityTableData) return <></>;

  return (
    <Grid container spacing={0.5} direction="row" alignItems="stretch">
      {/* Label column */}
      <Grid item xs={2}>
        <Card sx={{ padding: 3, display: "flex", flexDirection: "column", height: "60%", ...darkCard }}>
          <Typography variant="subtitle1" fontWeight="bold" sx={{ color: "#e0e6f0" }}>
            Average Power (MVA)
          </Typography>
        </Card>
      </Grid>

      {/* Data column */}
      <Grid item xs={10}>
        <Card sx={{ padding: 3, display: "flex", flexDirection: "column", height: "60%", ...darkCard }}>
          <Grid container spacing={2}>
            <Grid item xs={3} />
            <Grid item xs={3}>
              <Typography variant="subtitle1" fontWeight="bold" sx={{ color: "#e0e6f0" }}>
                Normalized Baseline:
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography variant="subtitle1" fontWeight="bold" sx={{ color: "#e0e6f0" }}>
                Assessment:
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography variant="subtitle1" fontWeight="bold" sx={{ color: "#e0e6f0" }}>
                Saving:
              </Typography>
            </Grid>

            <Grid item xs={3}>
              <Typography sx={{ color: "rgba(255,255,255,0.45)" }}>Weekdays, Evening</Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography sx={{ color: "#e0e6f0" }}>
                {(municipalityTableData?.weekday_evening_ls?.baseline_demand_total / 1000000 || 0).toFixed(2)} MVA
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography sx={{ color: "#e0e6f0" }}>
                {(municipalityTableData?.weekday_evening_ls?.assessment_demand_total / 1000000 || 0).toFixed(2)} MVA
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography sx={{ color: "#e0e6f0" }}>
                {Math.max(
                  municipalityTableData?.weekday_evening_ls?.baseline_demand_total / 1000000 -
                  municipalityTableData?.weekday_evening_ls?.assessment_demand_total / 1000000,
                  0
                ).toFixed(2)} MVA
              </Typography>
            </Grid>
          </Grid>
        </Card>
      </Grid>
    </Grid>
  );
}
